import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, inject, PLATFORM_ID, signal, viewChild, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { UserSettingsService } from 'src/app/services/user-settings/user-settings.service';
import { FeatureComponent } from 'src/app/shared/components/feature/feature.component';
import { IntroContainerComponent } from 'src/app/shared/components/intro-container/intro-container.component';
import { MapComponent } from 'src/app/shared/components/map/map.component';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { allPortalKinds, allPvpCategories, validMapCategories } from 'src/app/shared/models/pathfinder.models';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MapSettingsComponent } from './settings/map-settings.component';
import { MapsummaryComponent } from './summary/map-summary.component';

@Component({
  selector: 'app-albion-map',
  imports: [
    MapComponent,
    MatTabsModule,
    MatButtonModule,
    SectionComponent,
    FeatureComponent,
    IntroContainerComponent,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MapSettingsComponent,
    MapsummaryComponent
],
  templateUrl: './albion-map.component.html',
  styleUrl: './albion-map.component.scss',
})
export class AlbionMapComponent {
  @ViewChild('map') mapComponent?: MapComponent;
  disableSaveConfig = signal(false);
  userSettingsService = inject(UserSettingsService);
  portalKinds = allPortalKinds;
  pvpCategories = allPvpCategories;
  mapCategories = validMapCategories;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  onTabChange(event: MatTabChangeEvent) {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.mapComponent) return;
      if (event.index === 2 && this.mapComponent.mapManager?.map) {
        this.mapComponent.mapManager.map.invalidateSize();
      }
    }
  }
}
